<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <strong>Ομάδες Υπηρεσιών</strong>
          <CButton color="success" size="sm" class="float-right" @click="openCreateModal">
            + Νέα Ομάδα
          </CButton>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="groups"
            :fields="fields"
            hover
            striped
            :items-per-page="10"
            pagination
          >
            <template #services="{item}">
              <td>
                <CBadge
                  v-for="service in item.services"
                  :key="service.id"
                  color="info"
                  class="mr-1 mb-1"
                >
                  {{ service.name }}
                </CBadge>
                <span v-if="!item.services || item.services.length === 0" class="text-muted">
                  Κανένα πρότυπο
                </span>
              </td>
            </template>
            <template #actions="{item}">
              <td>
                <CButton color="primary" size="sm" class="mr-1" @click="openEditModal(item)">
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton color="danger" size="sm" @click="confirmDelete(item)">
                  <CIcon name="cil-trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- Create/Edit Modal -->
    <CModal :show.sync="showModal" :centered="true" :title="modalTitle">
      <CInput
        label="Όνομα Ομάδας"
        v-model="form.name"
        placeholder="π.χ. ISO 17021-1"
        :is-valid="formError ? false : null"
        :invalid-feedback="formError"
      />
      <template #footer>
        <CButton color="secondary" @click="showModal = false">Ακύρωση</CButton>
        <CButton color="primary" @click="saveGroup" :disabled="saving">
          {{ saving ? 'Αποθήκευση...' : 'Αποθήκευση' }}
        </CButton>
      </template>
    </CModal>

    <!-- Delete Confirmation Modal -->
    <CModal :show.sync="showDeleteModal" :centered="true" title="Επιβεβαίωση Διαγραφής" color="danger">
      <p>Είστε σίγουροι ότι θέλετε να διαγράψετε την ομάδα <strong>{{ deleteItem ? deleteItem.name : '' }}</strong>;</p>
      <p v-if="deleteItem && deleteItem.services && deleteItem.services.length > 0" class="text-warning">
        <strong>Προσοχή:</strong> Η ομάδα περιέχει {{ deleteItem.services.length }} πρότυπα που θα μείνουν χωρίς ομάδα.
      </p>
      <template #footer>
        <CButton color="secondary" @click="showDeleteModal = false">Ακύρωση</CButton>
        <CButton color="danger" @click="deleteGroup" :disabled="deleting">
          {{ deleting ? 'Διαγραφή...' : 'Διαγραφή' }}
        </CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ServiceGroups',
  data() {
    return {
      groups: [],
      fields: [
        { key: 'name', label: 'Όνομα Ομάδας', sorter: true },
        { key: 'services', label: 'Πρότυπα (ISO)' },
        { key: 'actions', label: 'Ενέργειες', sorter: false, filter: false }
      ],
      showModal: false,
      showDeleteModal: false,
      editMode: false,
      form: {
        id: null,
        name: ''
      },
      formError: '',
      saving: false,
      deleting: false,
      deleteItem: null
    }
  },
  computed: {
    modalTitle() {
      return this.editMode ? 'Επεξεργασία Ομάδας' : 'Νέα Ομάδα'
    }
  },
  methods: {
    loadGroups() {
      axios.get('/api/service-groups?token=' + localStorage.getItem('api_token'))
        .then(response => {
          this.groups = response.data.groups || []
        })
        .catch(error => {
          console.error('Error loading groups:', error)
        })
    },
    openCreateModal() {
      this.editMode = false
      this.form = { id: null, name: '' }
      this.formError = ''
      this.showModal = true
    },
    openEditModal(item) {
      this.editMode = true
      this.form = { id: item.id, name: item.name }
      this.formError = ''
      this.showModal = true
    },
    saveGroup() {
      if (!this.form.name.trim()) {
        this.formError = 'Το όνομα είναι υποχρεωτικό'
        return
      }
      this.saving = true
      this.formError = ''

      const request = this.editMode
        ? axios.put('/api/service-groups/' + this.form.id + '?token=' + localStorage.getItem('api_token'), { name: this.form.name })
        : axios.post('/api/service-groups?token=' + localStorage.getItem('api_token'), { name: this.form.name })

      request
        .then(() => {
          this.showModal = false
          this.loadGroups()
        })
        .catch(error => {
          if (error.response && error.response.data.errors) {
            this.formError = error.response.data.errors.name[0]
          } else {
            this.formError = 'Σφάλμα κατά την αποθήκευση'
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
    confirmDelete(item) {
      this.deleteItem = item
      this.showDeleteModal = true
    },
    deleteGroup() {
      if (!this.deleteItem) return
      this.deleting = true

      axios.delete('/api/service-groups/' + this.deleteItem.id + '?token=' + localStorage.getItem('api_token'))
        .then(() => {
          this.showDeleteModal = false
          this.deleteItem = null
          this.loadGroups()
        })
        .catch(error => {
          console.error('Error deleting group:', error)
          alert('Σφάλμα κατά τη διαγραφή')
        })
        .finally(() => {
          this.deleting = false
        })
    }
  },
  mounted() {
    this.loadGroups()
  }
}
</script>

<style scoped>
.mr-1 {
  margin-right: 0.25rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
</style>
